import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const LiquidityField = () => {
    const value = useStandardLoanStore((state) => state.loan.liquidity);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanLiquidity'
            value={value}
            onChange={(amount) => updateLoan({ liquidity: toPositiveNumber(amount) })}
            label='Liquidity'
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
